export default "/sponsors.f0a4da18-3dbb40.gif";